import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';
import { nullableNumericQuerySchema, paginatedResponseSchema } from '@/_schemas/generic';

import { inventoryCategoryQueryLinkerSchema } from './inventory-category-query-linker-schema';

export const inventorCategoryQuerySchema = z.object({
  ...inventoryCategoryQueryLinkerSchema.shape,
  sku_label: z.string().nullable(),
  sku_start_number: nullableNumericQuerySchema(),
  icon: z.array(fileQuerySchema).nullish(),
});

export type InventorCategoryQuerySchema = z.infer<typeof inventorCategoryQuerySchema>;

export const inventorCategoryQueryAllSchema = paginatedResponseSchema(inventorCategoryQuerySchema);

export type InventorCategoryQueryAllSchema = z.infer<typeof inventorCategoryQueryAllSchema>;
